import { createSlice } from "@reduxjs/toolkit";
import { setCompanyData, setCompany, clearCompany, clearCompanyData } from "../database/selectedCompanySlice";

const initialState = {
	data: null,
	loading: false,
	error: null,
};

// The list belongs to the company it was fetched in. When the selected company changes it is wrong
// for the new one, so it's dropped (the page then shows its loader, not another company's tasks).
const resetForCompanyChange = () => initialState;

// Unassigned Tasks: open tasks nobody has claimed yet that are offered to the user (candidate user
// or one of their roles). Its own slice, not pendingTasks: the two pages show different lists, and
// sharing a slice made one page briefly show the other's rows.
const unassignedTasksSlice = createSlice({
	name: "unassignedTasks",
	initialState,
	reducers: {
		// payload: { request, needsLabels } - see workflowsSaga (getUnassignedTasksSaga).
		fetchUnassignedTasksRequest: (state) => {
			state.loading = true;
			state.error = null;
		},
		fetchUnassignedTasksSuccess: (state, action) => {
			state.loading = false;
			state.data = action.payload;
		},
		fetchUnassignedTasksFailure: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
		// A response that arrived after the company changed was discarded: just stop loading.
		fetchUnassignedTasksDiscarded: (state) => {
			state.loading = false;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(setCompanyData, resetForCompanyChange)
			.addCase(setCompany, resetForCompanyChange)
			.addCase(clearCompany, resetForCompanyChange)
			.addCase(clearCompanyData, resetForCompanyChange);
	},
});

export const {
	fetchUnassignedTasksRequest,
	fetchUnassignedTasksSuccess,
	fetchUnassignedTasksFailure,
	fetchUnassignedTasksDiscarded,
} = unassignedTasksSlice.actions;

export default unassignedTasksSlice.reducer;
